import { apiClient } from './api'
import type { HeartbeatPayload } from '@/types'

export const presenceApi = {
  heartbeat(payload: HeartbeatPayload) {
    return apiClient.post<{ online_status: number; server_ts: number }>('/presence/heartbeat', payload)
  },
}
